<template>
  <div class="iv-user-info iv-p-20">
    <header class="iv-user-info-header">
      <img class="iv-user-info-header-top" :src="photoSrc" @error="nofind">
    </header>
    <h3 class="iv-fs-18 iv-fc-85 iv-text-center iv-user-info-header-userName" style="margin-top: 52px;">
      <span>{{userInfo.userName}}</span>
      <div class="iv-user-info-header-organ">
        <Poptip trigger="hover" placement="bottom">
          <img v-if="userInfo.djPartyDuty" class="iv-m-l-16 iv-m-r-8 iv-pointer" src="@/assets/images/index/dang.png" alt="">
          <div class="iv-user-info-header-organ-content" slot="content">
            <p v-for="(item, index) in userInfo.djPartyDuty" :key="index" class="iv-m-b-4">
              <img class="iv-m-r-16 iv-pointer" src="@/assets/images/index/dang.png" alt="">
              <span class="iv-fs-14">{{item}}</span>
            </p>
          </div>
        </Poptip>
        <Poptip trigger="hover" placement="bottom">
          <img v-if="userInfo.gjPartyDuty" class="iv-m-r-8 iv-pointer" src="@/assets/images/index/hui.png" alt="">
          <div class="iv-user-info-header-organ-content" slot="content">
            <p v-for="(item, index) in userInfo.gjPartyDuty" :key="index" class="iv-m-b-4">
              <img class="iv-m-r-16 iv-pointer" src="@/assets/images/index/hui.png" alt="">
              <span class="iv-fs-14">{{item}}</span>
            </p>
          </div>
        </Poptip>
        <Poptip trigger="hover" placement="bottom">
          <img v-if="userInfo.tjPartyDuty" class="iv-pointer" src="@/assets/images/index/tuan-new.png" alt="">
          <div class="iv-user-info-header-organ-content" slot="content">
            <p v-for="(item, index) in userInfo.tjPartyDuty" :key="index" class="iv-m-b-4">
              <img class="iv-m-r-16 iv-pointer" src="@/assets/images/index/tuan-new.png" alt="">
              <span class="iv-fs-14">{{item}}</span>
            </p>
          </div>
        </Poptip>
      </div>
    </h3>
    <p class="iv-fs-16 iv-fc-45 iv-text-center iv-m-t-8">{{userInfo.userCode}}</p>
    <p class="iv-fs-16 iv-fc-45 iv-m-t-20 iv-user-info-grey iv-text-center">
      <span>{{getPolity()}}</span>
    </p>
    <div class="iv-m-t-20 iv-user-info-tag-wrap iv-p-b-20">
      <Tag type="border" class="iv-user-info-tag iv-m-r-20" @click.native="toOrgTargetPage">组织目标</Tag>
      <Tag type="border" class="iv-user-info-tag" @click.native="toPartyPersonPage">党员联系员工</Tag>
    </div>
    <Row class-name="iv-user-info-icon iv-p-t-20">
      <Col :span="12" class-name="iv-pointer iv-user-info-icon-col iv-p-l-28">
        <Iconfont type="gerenxinxi1" class="iv-fs-24 iv-fc-25" @click="toPersonalPage"></Iconfont>
        <span class="iv-fc-45 iv-fs-16 iv-m-l-16 iv-user-info-icon-dang" @click="toPersonalPage">个人信息</span>
      </Col>
      <Col :span="12" class-name="iv-pointer iv-text-center iv-user-info-icon-col iv-p-r-28">
        <Iconfont type="jifen1" class="iv-fs-24 iv-fc-25" @click="viewPoints"></Iconfont>
        <span class="iv-fc-45 iv-fs-16 iv-m-l-16 iv-user-info-icon-dang" @click="viewPoints">个人积分</span>
      </Col>
    </Row>
    <Modal title="入会申请书" v-model="isShowModal" className="iv-user-info-modal">
      <section class="iv-user-info-modal-content iv-text-center">
        <p class="iv-fs-32 iv-fc-65">京东方科技集团股份有限公司总部工会</p>
        <h1 class="iv-fs-32 iv-fc-85 iv-m-t-24" style="font-weight: 500;">入会申请书</h1>
        <p class="iv-fs-16 iv-fc-65 iv-text-left iv-m-t-24 iv-user-info-modal-main">我自愿加入京东方科技集团股份有限公司总部工会，遵守工会章程，执行工会决议，积极参加工会活动，为把我国建设成为富强、民主、文明的社会主义国家而努力奋斗。</p>
        <div class="iv-text-right iv-user-info-modal-bg"> <!-- iv-active-bg -->
          <p class="iv-fs-16 iv-fc-65 iv-p-r-12 iv-p-t-28">申请人：<span>于祯</span></p>
          <p class="iv-fs-16 iv-fc-65 iv-m-t-16 iv-p-r-12">{{timeFormat(new Date(), `yyyy年MM月dd日`)}}</p>
        </div>
      </section>
      <div slot="footer">
        <Button type="sure" @click="agree">同意</Button>
        <Button type="cancel" @click="refuse">拒绝</Button>
        <!-- <Button type="close" @click="refuse">关闭</Button> -->
      </div>
    </Modal>
    <Modal title="系统提示" size="small" v-model="pointsModal" className="iv-points-info-modal">
      <div class="iv-p-24 iv-text-center">
        <p class="iv-fs-16 iv-fc-65 iv-text-left">功能将在后期上线，敬请期待...</p>
        <img class="iv-m-t-8" style="height: 173px;" src="@/assets/images/index/no-points.png" >
      </div>
      <div slot="footer">
        <Button type="close" @click="refusePointsModal">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/modal'
import { timeFormat } from '@/utils'
import Iconfont from '@/components/iconfont'

export default {
  name: 'userInfo',
  data () {
    return {
      isShowModal: false,
      userInfo: {},
      pointsModal: false, //个人积分弹框
      photoSrc: ''
    }
  },
  mounted () {
    this.getUserOrganization()
  },
  methods: {
    timeFormat,
    //获取头像
    getUserHeaderPhoto () {
      this.$ajax({
        url: 'api-uum/module/portal/user/getPhoto',
        method: 'get',
        data: {
          userCode: this.userInfo.userCode
        },
        responseType: 'arraybuffer'
      }).then((response) => {
        this.photoSrc = `data:image/png;base64,${btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))}`
      })
    },
    getUserOrganization () {
      this.$ajax({
        url: 'api-uum/uuminfo/getUserInfo',
        method: 'get',
        data: {}
      }).then(({data}) => {
        this.userInfo = data.data
        if (this.userInfo.djPartyDuty) {
          this.userInfo.djPartyDuty = this.userInfo.djPartyDuty.split(',')
        }
        if (this.userInfo.gjPartyDuty) {
          this.userInfo.gjPartyDuty = this.userInfo.gjPartyDuty.split(',')
        }
        if (this.userInfo.tjPartyDuty) {
          this.userInfo.tjPartyDuty = this.userInfo.tjPartyDuty.split(',')
        }
        sessionStorage.setItem('orgPath', this.$encode(this.userInfo.orgPath || ''))
        this.getUserHeaderPhoto()
      })
    },
    //个人积分
    viewPoints () {
      this.pointsModal = true
    },
    refusePointsModal () {
      this.pointsModal = false
    },
    //个人信息
    toPersonalPage () {
      this.$router.push({
        name: 'userInfo'
      })
    },
    //党员信息
    personPoints (type) {
      this.$router.push({
        name: type == 'YWX01' ? 'partyInfo' : (type == 'YWX04' ? 'leagueInfo' : 'fullInfo')
      })
    },
    //组织目标
    toOrgTargetPage () {
      // this.$router.push({
      //   name: 'orgTarget'
      // })
      this.pointsModal = true
    },
    //党员联系员工
    toPartyPersonPage () {
      // this.$router.push({
      //   name: 'contact'
      // })
      this.pointsModal = true
    },
    //入会申请
    showModal () {
      this.isShowModal = true
    },
    //同意
    agree () {
      this.isShowModal = false
    },
    //拒绝
    refuse () {
      this.isShowModal = false
    },
    getPolity () {
      // 1、有+有：正常显示
      // 2、有+无：仅显示：政治面貌
      // 3、无+有：仅显示：岗位信息
      // 4、无+无：无岗位信息
      if (!this.userInfo.polityName && !this.userInfo.jobName) {
        return '无岗位信息'
      } else if (!this.userInfo.polityName) {
        return this.userInfo.jobName
      } else if (!this.userInfo.jobName) {
        return this.userInfo.polityName
      } else {
        return this.userInfo.polityName + '  ' + this.userInfo.jobName
      }
    },
    nofind () {
      var img = event.srcElement
      img.src = require('@/assets/images/user/header-3.png')
      img.onerror = null
    }
  },
  components: {
    Modal,
    Iconfont
  }
}
</script>

<style lang="scss" scoped>
.iv-user-info {
  width: 384px;
  height: 476px;
  background: #FFFFFF;
  border-radius: 16px;
  .iv-user-info-header {
    position: relative;
    height: 80px;
    border-radius: 8px;
    background-image: url('~@/assets/images/user-bg.png');
    .iv-user-info-header-top {
      width: 92px;
      height: 92px;
      border-radius: 50%;
      position: absolute;
      top: 20px;
      left: 50%;
      margin-left: -46px;
    }
  }
  .iv-user-info-header-userName {
    display: flex;
    align-items: center;
    justify-content: center;
    .iv-user-info-header-organ {
      height: 18px;
      margin-top: -4px;
      img {
        width: 18px;
        height: 18px;
      }
      .iv-user-info-header-organ-content {
        padding: 8px 8px;
        p {
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .iv-user-info-grey {
    padding: 20px 16px;
    background-color: #F5F7FA;
    border-radius: 8px;
  }
  .iv-user-info-tag-wrap {
    border-bottom: 1px solid rgba(0, 0, 0, 0.09);
    .iv-user-info-tag {
      width: 162px;
      height: 40px;
      text-align: center;
      font-size: 16px;
      line-height: 40px !important;
      margin: 0;
      border-radius: 8px;
      /deep/ .ivu-tag-text {
        color: rgba(0, 0, 0, 0.65) !important;
      }
    }
  }
  .iv-user-info-icon {
    .iconfont {
      font-size: 36px;
    }
    .iv-user-info-icon-col {
      display: flex;
      align-items: center;
      height: 64px;
      &:first-child {
        border-right: 1px dashed #E8E8E8;
      }
      &:last-child {
        justify-content: flex-end;
      }
      img {
        width: 52px;
        height: 52px;
      }
      .iv-user-info-icon-dang {
        font-size: 16px;
      }
    }
  }
}
.iv-user-info-modal {
  .iv-user-info-modal-content {
    padding: 48px 20px 24px 24px;
    .iv-user-info-modal-main {
      text-indent: 2em;
    }
    .iv-user-info-modal-bg {
      height: 94px;
      margin-top: 64px;
    }
    .iv-active-bg {
      background: url('~@/assets/images/index/chuo.png') no-repeat 98% center;
    }
  }
}
</style>
